module.exports = __webpack_public_path__ + "img/transferPAY.452e7998.svg";